import React, { useMemo } from 'react';
import Title from 'antd/lib/typography/Title';
import Paragraph from 'antd/lib/typography/Paragraph';
import { useTranslation } from 'react-i18next';
import { IDevice } from '@pages/Assets/Inventory/types';

interface IUValidation {
  devicesProps: IDevice[] | undefined;
  uploadedDevices: any;
  actionKey: number;
  manualUpload?: any;
  extraKey?: number;
}

const useValidation = ({
  devicesProps,
  uploadedDevices,
  actionKey,
  manualUpload,
  extraKey,
}: IUValidation) => {
  const { t: translate } = useTranslation(['device-actions-modal']);

  const validationStep = useMemo(
    () => ({
      title: translate('steps.validation'),
      content: (
        <div>
          <div className="action-network-reset">
            <Title level={5}>
              {translate('selected-device', {
                count:
                  // eslint-disable-next-line no-nested-ternary
                  manualUpload && manualUpload.length > 0
                    ? manualUpload.length
                    : devicesProps && devicesProps.length > 0
                    ? devicesProps?.length
                    : uploadedDevices.length,
              })}
            </Title>
            <Paragraph>
              {translate('action-confirm-message', {
                actionKey: translate(
                  actionKey === 0 || actionKey === 1
                    ? `device-actions:labels.activation`
                    : `device-actions:labels.${extraKey ?? actionKey}`,
                ),
                count:
                  // eslint-disable-next-line no-nested-ternary
                  manualUpload && manualUpload.length > 0
                    ? manualUpload.length
                    : devicesProps && devicesProps.length > 0
                    ? devicesProps?.length
                    : uploadedDevices.length,
              })}
            </Paragraph>
          </div>
        </div>
      ),
    }),
    [
      translate,
      manualUpload,
      devicesProps,
      uploadedDevices.length,
      actionKey,
      extraKey,
    ],
  );

  return { validationStep };
};

export default useValidation;
